import React from 'react'

function LegalQuestionAndAnsers() {
  return (
    <div>LegalQuestionAndAnsers</div>
  )
}

export default LegalQuestionAndAnsers